module.exports = __webpack_public_path__ + "static/media/defaultLinkGreen.c4b5a0da.svg";